module.exports = __webpack_public_path__ + "static/about-us-featured-985f87b47808c8371956b32ced0217e5.png";